import React from "react";
import ReactAudioPlayer from "react-audio-player";

export default ({ a }) => (
    <ReactAudioPlayer
        src={`/audio/${a}.mp3`}
        controls
        style={{ width: "100%", marginBottom: "1rem" }}
    />
);